<a
  [href]="'/' + region().slug"
  class="country-region-card region-card text-decoration-none"
  [class.country-region-card-t2]="theme() === GbTheme.ThemeTwo"
  (click)="$event.preventDefault(); onRegionClick()"
>
  <div class="card-header">
    <div [class.head-row-t2]="theme() === GbTheme.ThemeTwo">
      <span class="country-region-flag region-flag">
        <img class="img-fluid" [src]="region().flagUrl" [alt]="region().name" />
      </span>

      @if (theme() === GbTheme.ThemeTwo) {
        <span [class.name-supported-countries-container-t2]="theme() === GbTheme.ThemeTwo">
          <p class="country-region-name primary-font-semibold">
            {{ 'region_names.' + region().slug | translate }}
          </p>

          <p class="supported-countries-count primary-font-semibold">
            {{ region().supportedCountries.length }}
            {{ 'buy_plan.destination.countries' | translate }}
          </p>
        </span>
      }
    </div>

    <span class="next-arrow rtl">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="16"
        viewBox="0 0 25 16"
        fill="none"
      >
        <path
          d="M16.4496 15L23.5 8M23.5 8L16.4496 1M23.5 8L-9.60194e-07 8"
          stroke="#3D38D0"
          stroke-width="1.5"
        />
      </svg>
    </span>
  </div>

  @if (theme() === GbTheme.ThemeOne) {
    <span>
      <p class="country-region-name primary-font-semibold">
        {{ 'region_names.' + region().slug | translate }}
      </p>

      <p class="supported-countries-count primary-font-semibold">
        {{ region().supportedCountries.length }} {{ 'buy_plan.destination.countries' | translate }}
      </p>
    </span>
  }
</a>
